import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ProductConcept } from '../../models';
import { CloudPimPropertiesHelperService } from '../../services/cloud-pim-properties-helper/cloud-pim-properties-helper.service';

@Component({
    selector: 'lib-concept-detail-v2-top-details',
    templateUrl: './concept-detail-v2-top-details.component.html',
    styleUrls: ['./concept-detail-v2-top-details.component.css'],
    standalone: false
})
export class ConceptDetailV2TopDetailsComponent implements OnInit {
  @Input()
  concept: ProductConcept;
  @Input()
  isAnonymous?: boolean;
  currentLang = this.translateService.currentLang;
  public hasPimPropertiesToShow = false;
  public hasPimGroupsToShow = false;
  
  constructor(protected translateService: TranslateService, protected cloudPimPropertyHelper: CloudPimPropertiesHelperService) {}

  ngOnInit(): void {
    this.checkForPimProperties(this.concept);
  }

  public checkForPimProperties(concept: ProductConcept) {
    this.hasPimPropertiesToShow = this.cloudPimPropertyHelper.hasAnyPropertiesToShow(concept);

    if (!!this.hasPimPropertiesToShow) {
      this.hasPimGroupsToShow = this.cloudPimPropertyHelper.hasGroupsOnProductTemplates(concept);
    }
  }
}
